// extracted by mini-css-extract-plugin
module.exports = {"clientBox":"client_clientBox__BQH5z"};